import { JetView } from 'webix-jet';

/**
 * Class representing the payment prize view.
 * @extends JetView
 */
export default class PagoPremioView extends JetView {
    /**
     * Configures the layout of the payment prize form.
     * @returns {Object} The configuration object for the form.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section containing disabled text fields
        const left = {
            margin: 5,
            rows: [
                {
                    view: 'text',
                    name: 'ValorPagar', // Field for payment value
                    label: _('Valor a pagar'), // Localized label
                    labelPosition: 'top',
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'ValorApostado', // Field for bet value
                    label: _('Valor Apostado'), // Localized label
                    labelPosition: 'top',
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'PremioProyectado', // Field for projected prize
                    label: _('Premio Proyectado'), // Localized label
                    labelPosition: 'top',
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Estado', // Field for status
                    label: _('Estado'), // Localized label
                    labelPosition: 'top',
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Ganador', // Field for winner
                    label: _('Ganador'), // Localized label
                    labelPosition: 'top',
                    disabled: true, // Field is disabled
                },
            ],
        };

        // Center left section (currently empty)
        const center_left = {
            margin: 5,
            rows: [],
        };

        // Center right section (currently empty)
        const center_right = {
            margin: 5,
            rows: [],
        };

        // Right section (currently empty)
        const right = {
            margin: 5,
            rows: [],
        };

        // Upper section layout combining left, center, and right sections
        const upper_section = {
            cols: [
                left,
                { gravity: 0, minWidth: 10 }, // Spacer
                center_left,
                { gravity: 0, minWidth: 10 }, // Spacer
                center_right,
                { gravity: 0, minWidth: 10 }, // Spacer
                right,
            ],
        };

        // Button section with a payment button
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Pagar Premio'), // Localized button label
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        // Button click handler (currently empty)
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            id: 'formPagoPremio', // Unique ID for the form
            rows: [upper_section, buttons], // Form layout
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance.
     */
    init(form) {
        $$('formPagoPremio').hide(); // Initially hide the form
        this.on(this.app, 'pagoPremio:data', (premio) => {
            form.setValues(premio); // Set form values based on received data
            console.log('premio', premio); // Log the received prize data
        });
    }
}

// FILE DOCUMENTED
